<template>
    <link-dialog dialogClass="link-table-batch-modify-dialog"
                 v-model="p_show"
                 v-bind="dialogProps"
                 @confirm="pl_onConfirm"
                 @cancel="pl_onCancel">

        <pl-table-cell-controller class="link-table-batch-modify-dialog-list" ref="controller" tag="div" default-editing editable :required="false">
            <div class="link-table-batch-modify-dialog-item" v-for="(item,index) in result" :key="item.field+index">
                <link-select :width="150" :data="columns" labelKey="title" valKey="field" v-model="item.field" required validOnInit :afterSelect="e=>pl_afterSelect(e,item)" hideClearIcon/>
                <div class="link-table-batch-modify-dialog-item-edit">
                    <lv-scope-slot :scope-slot-func="item.col.colScopedSlot" :data="{row:row,editRow:row,rowIndex:0,col:item.col,colIndex:0}"/>
                </div>
                <link-icon icon="icon-close-circle-fill" class="link-table-batch-modify-dialog-item-delete" @click="pl_deleteItem(item,index)"/>
            </div>
            <div>
                <link-button label="清空" @click="clear" style="width:100px;height:32px;margin-right: 8px" type="line"/>
                <link-button label="新增" @click="add" style="width:100px;height:32px"/>
            </div>
        </pl-table-cell-controller>
    </link-dialog>
</template>

<script>
    import LvScopeSlot from "../../render/lv-scope-slot";
    import PlTableCellController from "../../table/pl-table-cell-controller";

    export default {
        name: "link-table-batch-modify-dialog",
        components: {PlTableCellController, LvScopeSlot},
        data() {
            const defaultDialogProps = {
                title: '批量修改',
                confirmButton: true,
                cancelButton: true,
                width: '500px',
                minHeight: '200px',
                maxHeight: '400px',
                disabledHideOnConfirm: true,
            }
            return {

                dialogProps: {...defaultDialogProps},
                defaultDialogProps,

                p_show: false,
                onConfirm: null,
                onCancel: null,
                columns: [],
                row: {},
                result: [],
            }
        },
        computed: {
            existColFields() {
                if (!this.result || this.result.length === 0) return null
                return this.result.map(item => item.field)
            },
            leftCols() {
                if (!this.existColFields) return this.columns
                return this.columns.filter(col => this.existColFields.indexOf(col.field) === -1)
            },
        },
        methods: {
            async show({columns, onConfirm, onCancel, dialogProps}) {

                this.columns = []
                this.onConfirm = null
                this.onCancel = null
                this.dialogProps = Object.assign({}, this.defaultDialogProps, dialogProps)

                this.row = {}
                this.result = []
                await this.$lv.nextTick()

                this.columns = columns
                this.onConfirm = onConfirm
                this.onCancel = onCancel
                this.add()

                this.p_show = true
            },
            async add() {
                if (!this.leftCols || this.leftCols.length === 0) {
                    this.$dialog.show('已经添加完所有可修改的字段！')
                    return
                }
                const col = this.leftCols[0]
                this.pl_setValue('null', col)
                this.result.push({
                    field: col.field,
                    col,
                })
            },
            async clear() {
                this.result.splice(0, this.result.length - 1)
            },
            pl_afterSelect(field, item) {
                if (!this.existColFields) return
                const targetCol = this.getColByField(field)
                const oldField = item.field

                if (this.existColFields.indexOf(field) > -1 && field !== item.field) {
                    this.$dialog.show(`已经存在要修改的字段：${targetCol.title}`)
                    this.$nextTick(() => item.field = oldField)
                    return;
                }
                item.col = targetCol
                this.pl_setValue('delete', this.getColByField(oldField))
                this.pl_setValue('null', targetCol)
            },
            getColByField(field) {
                if (!this.columns) return null
                for (let i = 0; i < this.columns.length; i++) {
                    const col = this.columns[i];
                    if (col.field === field) return col
                }
                return null
            },
            pl_deleteItem(item, index) {
                if (this.result.length === 1) {
                    this.$dialog.show('至少有一个需要修改的字段！')
                    return
                }
                this.pl_setValue('delete', item.col)
                this.result.splice(index, 1)
            },
            pl_setValue(deleteOrNull, col) {
                const deleteHandler = (field) => delete this.row[field]
                const nullHandler = (field) => this.$set(this.row, field, null)
                const handler = deleteOrNull === 'null' ? nullHandler : deleteHandler
                if (!!col.getChangeField) {
                    const fields = col.getChangeField(col)
                    fields.forEach(field => handler(field))
                } else {
                    handler(col.field)
                }
            },
            async pl_onConfirm() {
                !!this.onConfirm && await this.onConfirm(this.row)
                this.p_show = false
            },
            pl_onCancel() {
                !!this.onCancel && this.onCancel()
            },
        }
    }
</script>

<style lang="scss">
    @include themeify {
        .link-table-batch-modify-dialog-list {
            .link-table-batch-modify-dialog-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;

                .link-table-batch-modify-dialog-item-edit {
                    flex: 1;
                    box-sizing: border-box;
                    padding: 0 16px;

                    .link-dropdown, .link-dropdown-reference-wrapper, .link-input, .link-timepicker, .link-datepicker, .link-timepicker-ref, .pl-popover, .pl-popover-reference, .link-select, .pl-date, .pl-time {
                        width: 100% !important;
                    }

                    .lv-column-text {
                        justify-content: flex-start;
                    }
                }

                .link-table-batch-modify-dialog-item-delete {
                    color: pl-var(color-normal-content);
                    cursor: pointer;
                }
            }
        }

    }
</style>
